import axios from 'axios';
import { getCookie } from './plugins/userUtils';

export const subDomainURL = (subDomain, domain = document.domain) => {
  let domTail = domain.replace(/^[^\.]+./, '.');
  if (domain.match('-staging')) {
    domTail = `-staging${domTail}`;
  }
  return `https://${subDomain}${domTail}`;
};

const starApiConnector = (subDomain) => {
  const buIds = window.config.business_unit.path_ids_of_current_bu_structures;
  const ancestorBuIds = buIds.slice(0, buIds.indexOf(window.config.business_unit.id) + 1);

  let headers = {
    'X-EPERSONAM-BU-ID': `${window.config.business_unit.id}`,
    'X-ANCESTOR-BU-IDS': ancestorBuIds,
    Authorization: `Bearer ${getCookie('jwt')}`,
  };
  return axios.create({
    headers: headers,
    baseURL: subDomainURL(subDomain),
    withCredentials: true,
  });
};

export default starApiConnector;

export const warehouseApiConnector = () => starApiConnector('api-warehouse');
export const ePersonamApiConnector = () => starApiConnector('www');
